import React from 'react'
import styled from 'styled-components'

import { Margins, Colors } from '../../constants'

const ErrorContainer = styled.div`
  background-color: rgba(222, 97, 97, 0.25);
  padding: ${Margins.xs}px ${Margins.s}px;
  border-radius: 20px;
`

const ErrorText = styled.p`
  color: ${Colors.RED};
`

// Todo: Check error codes in this component
export const Error = ({ errorText }: { errorText: string }) => {
  return (
    <ErrorContainer>
      <ErrorText>{errorText}</ErrorText>
    </ErrorContainer>
  )
}
